import { render, staticRenderFns } from "./HeroAlt.vue?vue&type=template&id=0cdd7b3f"
import script from "./HeroAlt.vue?vue&type=script&lang=js"
export * from "./HeroAlt.vue?vue&type=script&lang=js"
import style0 from "./HeroAlt.vue?vue&type=style&index=0&id=0cdd7b3f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports